import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Img from "gatsby-image";

function BlogPost({post}) {
    const getLink = () => {
        if(post.title === 'Coming soon') {
            return "/blog";
        }
        else {
            return '/blog/' + post.slug;
        }
    }
    return(
        <div className="blog-post">
            <Link to={getLink()}>
                <div className="blog-post__thumb">
                    <Img 
                        fluid={post.thumbnailImage.fluid} 
                        key={post.thumbnailImage.fluid.src}
                        alt={post.thumbnailImage.title}
                    /> 
                </div>
                <div className="blog-post__body">
                    <h2>{post.title}</h2>
                    <div>{post.description.description}</div>
                </div>
                <div className="blog-post__readmore">
                    <div className="btn btn-default">READ MORE</div>
                </div>
            </Link>
        </div>
    );
};

BlogPost.propTypes = {
    post: PropTypes.object.isRequired
};

export default BlogPost;